export const specialMenu = {
    crypto: '暗号資産',
    virtualCard: 'バーチャルカード',
}
export const homeOneModule  = {
    title: '安全で安定した法人向けサービス',
    subTitle: '信頼できる高品質なサービス',
    descList: [
        {
            content: '10年にわたるサービス経験の蓄積'
        },
        {
            content: '9つのセキュリティ対策'
        },
        {
            content: '8つの利用シーン'
        },
    ]
}
export const homeTwoModule  = {
    title: 'グローバル資産を一括管理',
    subTitle: 'UBPayでは、ステーブルコインと法定通貨を1つのプラットフォームで管理できます'
}
export const homeThreeModule  = {
    title: 'UBPay：グローバルビジネスの最良パートナー',
    subTitle: 'ステーブルコインをミリ秒単位で即時変換。複数のシステムを切り替える必要がなく、市場変動リスクを軽減し、資産価値を守ります'
}
export const homeFourModule  = {
    title: '迅速・安全・効率的なグローバルバーチャルカードサービス',
    subTitleList: [
        {
            title: '高速発行、即時利用可能',
            subTitle: '即時発行＆即利用で、時間と労力を節約',
            img: require('@/assets/imgs/home/gaoxiao.png')
        },
        {
            title: '先進技術と強力なセキュリティ',
            subTitle: '安定した技術基盤により、カード管理や支払いがスムーズに',
            img: require('@/assets/imgs/home/jishu.png')
        },
        {
            title: '多通貨対応、便利な取引',
            subTitle: 'USD、EUR、GBPなど多様な通貨に対応し、為替損失を抑制',
            img: require('@/assets/imgs/home/bizhong.png')
        },
    ]
}
export const appDownload = {
    title: 'ダウンロード',
    desc: 'UBPayは、iOSおよびAndroid向けのモバイルアプリとして利用可能です',
}
export const footerUbpayDesc = {
    content: 'PACIFIC BANK と EAST BANK は共同で EAST CARD を設立し、グローバル本社はニューヨークと香港にあります。UB CARD および UB PAY ' +
        'をそれぞれ展開しており、シンガポールにも支店を設置しています。複数の国際的な銀行と戦略的パートナーシップを締結し、アジア太平洋地域における決済サービスの展開を推進しています。'
}
export const footerMenu = [
    {
        name: "製品とサービス",
        router: "index",
        url: "",
        childList: [
            {
                name: "マルチ通貨ウォレット",
                url: "multiWalletAndCcy",
            },
            {
                name: "ステーブルコイン変換",
                url: "transformCcy",
            },
            {
                name: "バーチャルバンクカード",
                url: "footerVirtualCard",
            },
            {
                name: "支払いと出金",
                url: "payment",
            },
            {
                name: "セキュリティ",
                url: "security",
            },
        ]
    },
    {
        name: "会社概要",
        router: "scienceResult",
        url: "",
        childList: [
            {
                name: "UBPayについて",
                url: "aboutUBPay",
            },
            {
                name: "お問い合わせ",
                url: "contactUs",
            }
        ]
    },
    {
        name: "Policies & Regulations",
        router: "productCenter",
        url: "",
        childList: [
            // {
            //     name: "利用規約",
            //     url: "termsOfUse",
            // },
            {
                name: "プライバシーポリシー",
                url: "privacyPolicy",
            },
            {
                name: "ヘルプセンター",
                url: "helpCenter",
            }
        ]
    },
    {
        name: "APP",
        router: "newsCenter",
        url: "",
        childList: [
            {
                name: "アプリダウンロード",
                url: "appDownload",
            }
        ]
    }
]
export const cryptoOneModule = {
    title: '複数の通貨とチェーンに対応',
    subTitle: '複数のブロックチェーン資産を1つのプラットフォームで自由に管理。EthereumでもTRONでも、簡単に切り替えて即時取引可能。'
}
export const cryptoTwoModule = {
    title: 'ステーブルコインから法定通貨への両替',
    subTitle: 'UBPayはステーブルコインをミリ秒レベルで即時変換し、システムの切替不要で、価格変動リスクを軽減し、資産価値を保護します。'
}
export const cryptoThreeModule = {
    title: '専門チームがあなたの暗号資産取引の安全を保証します。',
    threeList: [
        {
            content: '低手数料'
        },
        {
            content: '分散型'
        },
        {
            content: '複数のパブリックチェーンに対応'
        },
        {
            content: '即時決済'
        },
        {
            content: 'ステーブルコインの両替に対応'
        },
        {
            content: '詐欺リスクを軽減'
        },
        {
            content: '世界中の暗号資産のチャージと出金に対応'
        },
        {
            content: '24時間年中無休のカスタマーサポート'
        },
    ]
}
export const virtualCardOneModule = {
    label: 'DiscoverとMastercardの二重チャネル対応',
    title: '世界中のオンライン支出に完全対応し、多様な支払いニーズに対応します',
    subTitleList: [
        {
            img: require('@/assets/imgs/home/gaoxiao2.png'),
            title: "即時カード発行、即時入金",
            content: "待ち時間なしでDiscover/Mastercardのバーチャルカードをオンライン申請、すぐにグローバル決済を開始"
        },
        {
            img: require('@/assets/imgs/home/jishu2.png'),
            title: "先進技術と強力なセキュリティ",
            content: "安定した技術基盤により、カード管理や支払いがスムーズに"
        },
        {
            img: require('@/assets/imgs/home/bizhong2.png'),
            title: "多通貨対応、便利な取引",
            content: "USD、EUR、GBPなど多様な通貨に対応し、為替損失を抑制"
        },
        {
            img: require('@/assets/imgs/home/baozhang.png'),
            title: "匿名・プライバシー重視",
            content: "本人確認なしで取得可能・高匿名性"
        }
    ]
}
export const virtualCardTwoModule = {
    title: 'DiscoverとMastercardの2種類のカード対応',
    cardGroup: [
        {
            name: 'Discover',
            descList: [
                {
                    content: 'お得な価格、快適な利用体験'
                },
                {
                    content: '多様な場面で利用可能、繰り返し使用可'
                },
                {
                    content: '共有限度額で企業のカード管理を効率化'
                }
            ]
        },
        {
            name: 'Mastercard',
            descList: [
                {
                    content: '多様な用途に対応し、幅広い加盟店で利用可能'
                },
                {
                    content: 'セキュリティと不正利用対策を完備'
                },
                {
                    content: '迅速で丁寧なカスタマーサービス'
                }
            ]
        }
    ]
}
export const virtualCardThreeModule = {
    title: '即時発行、簡単管理',
    openMgtList: [
        {
            title: '即時発行',
            content: '待ち時間なしでMastercard・Discoverのバーチャルカードを即時発行。すぐに使えて、グローバル決済を開始できます'
        },
        {
            title: '多通貨対応',
            content: 'USD、EUR、GBPなど多様な通貨に対応し、為替損失を抑制'
        },
        {
            title: '先進的で安定した技術',
            content: '安定かつ安全なインフラにより、スムーズなカード管理と取引処理を実現'
        },
        {
            title: '管理が簡単',
            content: '専用アプリで複数のカードを一括管理。いつでもカードの詳細を確認・操作できます'
        },
        {
            title: 'グローバル決済に対応',
            content: 'Alipay、WeChat Payなどの主要決済に対応。越境EC、海外通販、オフライン利用にもスムーズに対応'
        },
        {
            title: '手厚いサポートと万全の保障',
            content: '平日サポートで即時対応'
        }
    ]
}
export const virtualCardFourModule = {
    title: 'プライバシーを全面保護',
    privacyAndSecurityList: [
        {
            img: require('@/assets/imgs/home/rq.png'),
            title: "匿名・プライバシー重視",
            content: "本人確認なしで取得可能・高匿名性"
        },
        {
            img: require("@/assets/imgs/home/aq.png"),
            title: "安全・リスク管理対応",
            content: "毎回一意の番号で実カードと分離、情報漏洩を防止"
        },
        {
            img: require("@/assets/imgs/home/ed.png"),
            title: "柔軟・計画的な利用が可能",
            content: "上限設定＆審査不要、誰でも使える柔軟なバーチャルカード"
        },
    ]
}
export const popup = {
    prContent: {
        regulationsOne: {
            subTitle: '1，はじめに',
            content: '以下「当社」または「本プラットフォーム」といいますは、お客様のプ\n' +
                'ライバシーを尊重し、個人情報の保護に努めています。\n' +
                '本プライバシーポリシーでは、当社ウェブサイトの閲覧、サービスの利用、または\n' +
                '当社とのやり取りに際して、どのように情報を収集・利用・開示・保護するかを定\n' +
                'めています。'
        },
        regulationsTwo: {
            subTitle: '2，収集する情報',
            content: '当社は、以下の情報を収集する場合があります：',
            list: [
                {
                    content: '個人識別情報（氏名、本人確認書類番号、住所、電話番号、メールアドレス等）'
                },
                {
                    content: '財務情報（銀行口座情報、ウォレットアドレス、取引履歴等）'
                },
                {
                    content: '技術情報（IPアドレス、ブラウザの種類、オペレーティングシステム等）'
                },
                {
                    content: '利用状況データ（ログイン履歴、クリック履歴、利用設定等）'
                },
                {
                    content: 'KYC情報（本人確認書類および関連情報）'
                }
            ]
        },
        regulationsThree: {
            subTitle: '3，情報の利用目的',
            content: '当社は、収集した情報を以下の目的で利用します：',
            list: [
                {
                    content: 'サービスの提供、運営、改善'
                },
                {
                    content: '本人確認および法令上の義務履行'
                },
                {
                    content: '取引の処理およびアカウントの管理'
                },
                {
                    content: '不正行為、マネーロンダリング、その他違法行為の防止'
                },
                {
                    content: 'サービスに関する通知、更新、プロモーション情報のご案内'
                }
            ]
        },
        regulationsFour: {
            subTitle: '4，情報の共有と開示',
            content: '当社は、お客様の個人情報を第三者に販売することはありません。\n' +
                'ただし、以下の場合には情報を共有または開示することがあります：',
            list: [
                {
                    content: '秘密保持契約を締結している関連会社及びサービス提供者への提供'
                },
                {
                    content: '法令に基づき、規制当局または捜査機関への開示'
                },
                {
                    content: 'お客様の同意を得た上で、業務提携先との共有（運営またはマーケティング目的）'
                }
            ]
        },
        regulationsFive: {
            subTitle: '5，個人情報の保存期間',
            content: '当社は、収集目的の達成または法令遵守のために必要な期間に限り、個人情報を保存します。'
        },
        regulationsSex: {
            subTitle: '6，データセキュリティ',
            content: '当社は、適切な技術的および組織的安全対策を講じ、不正アクセス、漏洩、改ざん、破壊等から個人情報を保護します。'
        },
        regulationsSeven: {
            subTitle: '7，お客様の権利',
            content: 'お客様は、以下の権利を有します：',
            list: [
                {
                    content: 'ご自身の個人情報へのアクセスおよび訂正の要求'
                },
                {
                    content: '個人情報の削除または処理の制限の要求'
                },
                {
                    content: 'いつでも同意を撤回する権利'
                },
                {
                    content: '所轄の個人情報保護監督機関への苦情申し立て'
                }
            ]
        },
        regulationsEight: {
            subTitle: '8，Cookieおよび追跡技術',
            content: '当社は、クッキー及び類似の追跡技術を利用し、ユーザー体験の向上、ウェブサイトの利用状況分析、及びパーソナライズされたコンテンツ提供を行っています。'
        },
        regulationsNine: {
            subTitle: '9，国際的なデータ移転',
            content: 'お客様の個人情報は、お客様の居住国以外の国・地域で処理または保存される場合があります。'
        },
        regulationsTen: {
            subTitle: '10，プライバシーポリシーの改訂',
            content: '当社は、本プライバシーポリシーを必要に応じて改訂することがあります。\n' +
                '重大な変更がある場合には、当社ウェブサイトまたはその他適切な手段により通知いたします。'
        }
    },
    helpCenterList: [
        {
            title: '1，UBPayユーザーとして登録する方法？',
            content: 'UBPayアプリをダウンロードし、起動後に「登録」をタップ。メールアドレスで登録可能です。認証コードを受信後、コードとパスワードを入力し、利用規約に同意して送信すればアカウント作成完了です。'
        },
        {
            title: '2，UBPayの利用にはKYCが必要ですか？',
            content: '暗号資産のチャージについては、一部の地域で本人確認なしで利用可能です。ただし、銀行カードの申請にはKYCが必要です。身分証（例：IDカード、パスポート、運転免許証）の提出が必要で、審査時間は通常1〜12時間です。'
        },
        {
            title: '3，登録済みのメールアドレスは変更できますか？',
            content: 'はい。個人設定ページからログイン用メールアドレスの変更が可能です。新しいメールアドレスを入力し、認証コードで確認してください。'
        },
        {
            title: '4，パスワードを忘れた場合は？',
            content: 'ログイン画面の「パスワードをお忘れですか？」をタップし、メールアドレスを入力してください。認証コードを受け取って再設定できます。頻繁なリセットはリスク管理対象になる可能性があります。'
        },
        {
            title: '5，1人で複数のUBPayアカウントを登録できますか？？',
            content: 'リスク管理上の観点から、複数アカウントの登録は推奨しておりません。'
        },
        {
            title: '6，どのカードが申請できますか？',
            content: 'MastercardおよびDiscover® Global Networkのカードをご提供しています。実体カードとバーチャルカードの両方があり、バーチャルカードは即時発行が可能です。'
        },
        {
            title: '7，バーチャル銀行カードとは？',
            content: 'バーチャル銀行カードは、提携機関によって発行されるもので、カード番号、有効期限、CVVが含まれた仮想カードです。オンライン決済では物理カードと同様に機能しますが、より高い利便性、匿名性、安全性を備えています。'
        },
        {
            title: '8，バーチャルカードはどこで使えますか？',
            content: 'UBPayのバーチャルカードは、Alipay、WeChat Pay、Apple Pay、Google Pay、PayPalなどのウォレットに連携可能で、オンライン決済に利用できます。一部ATMで現金引き出しも可能です。'
        },
        {
            title: '9，対応している通貨は？',
            content: 'USD、EUR、GBPに対応しています。利用地域に応じて自動で換算されるマルチ通貨カードも提供しており、両替手数料を回避できます。'
        },
        {
            title: '10，バーチャルカードの有効期間はどのくらいですか？',
            content: 'UBPayのバーチャルカードの有効期限は通常1〜2年で、1年経過後にもう1年延長できます。有効期限は通常カードの詳細画面で確認できます。'
        }
    ],
    tfVersionDownloadTitle: 'TFバージョンダウンロードガイド',
    tfVersionDownload: [
        {
            content: '1，TestFlight をダウンロード：iOS デバイスの App Store を開き、「TestFlight」と検索し、TestFlight アプリを見つけて「入手」をタップしてダウンロードとインストールを行います。'
        },
        {
            content: '2，招待を取得：開発者は App Store Connect で公開テストリンクを作成するか、特定のユーザーに招待メールを送信します。ユーザーは招待リンクを含むメールを受け取るか、開発者から提供された他のチャネルからリンクを取得します。'
        },
        {
            content: '3，招待リンクを使用：招待リンクをクリックすると、システムが自動的に TestFlight アプリを開きます。自動で開かない場合は手動で TestFlight を開いてください。'
        },
        {
            content: '4，アプリをインストール：TestFlight アプリ内で「テストを開始」ボタンをクリックし、「インストール」ボタンをクリックします。アプリのダウンロードとインストールが完了するまで待ちます。完了後、ホーム画面からアプリを見つけて開くことができます。'
        }
    ]
}
export const aboutUBPay = {
    title: 'UBPayについて',
    content: {
        subTitle: 'UBPayは次世代の暗号通貨決済システムを構築し、世界中の企業・個人に安全・高速・コンプライアンス対応の決済を提供します。',
        content: '企業が暗号資産を導入できるよう、EthereumやTRONなどに対応した決済・両替・清算・出金の一括サービスを提供しています。'
    }
}
export const contactUs = {
    title: 'お問い合わせ',
    contactEmailMethod: 'メールでお問い合わせ',
    contactMediumMethod: 'ソーシャルメディア',
    contactForm: {
        title: '私たちに相談する必要がありますか？連絡先を残してください',
        name: 'お名前',
        email: 'メールアドレス',
        message: 'メッセージ',
        submit: '送信'
    }
}
